import { render, staticRenderFns } from "./ProfileEmail.vue?vue&type=template&id=128ded9d&scoped=true&"
import script from "./ProfileEmail.vue?vue&type=script&lang=ts&"
export * from "./ProfileEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEmail.vue?vue&type=style&index=0&id=128ded9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ded9d",
  null
  
)

export default component.exports